import * as Apollo from "@apollo/client";
import { gql } from "@apollo/client";

//#region src/generated/graphql.tsx
const defaultOptions = {};
const AsinsInfoFragmentDoc = gql`
    fragment asinsInfo on ASIN {
  asin
  description
  id
}
    `;
const ProgramsInfoFragmentDoc = gql`
    fragment programsInfo on Program {
  id
  name
}
    `;
const UserDocument = gql`
    query User {
  user @client {
    alias
    email
    groups
  }
}
    `;
const DbmAsinsDocument = gql`
    query DbmAsins($first: Int!, $filters: AsinFilterInput) {
  asins(first: $first, filters: $filters) {
    nodes {
      ...asinsInfo
      party
      announceDate
      liveness
      type
      productId
      marketplace {
        id
        obfuscatedMarketplaceId
        country
      }
      program {
        id
        name
      }
      productLine {
        id
        name
      }
    }
  }
}
    ${AsinsInfoFragmentDoc}`;
/**
* __useDbmAsinsQuery__
*
* To run a query within a React component, call `useDbmAsinsQuery` and pass it any options that fit your needs.
* When your component renders, `useDbmAsinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
* you can use to render your UI.
*
* @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
*
* @example
* const { data, loading, error } = useDbmAsinsQuery({
*   variables: {
*      first: // value for 'first'
*      filters: // value for 'filters'
*   },
* });
*/
function useDbmAsinsQuery(baseOptions) {
	const options = {
		...defaultOptions,
		...baseOptions
	};
	return Apollo.useQuery(DbmAsinsDocument, options);
}
function useDbmAsinsLazyQuery(baseOptions) {
	const options = {
		...defaultOptions,
		...baseOptions
	};
	return Apollo.useLazyQuery(DbmAsinsDocument, options);
}
const CreateBundleDocument = gql`
    mutation createBundle($input: CreateBundleRequest!) {
  createBundle(input: $input) {
    bundleEntities {
      id
      bundleForm {
        title
        autoGeneratedCreativeName
        bindingType
        autogenerateBulletPoints
        autogenerateTitle
        bullets
      }
      submissionDate
      status
      errorRecord
    }
  }
}
    `;
/**
* __useCreateBundleMutation__
*
* To run a mutation, you first call `useCreateBundleMutation` within a React component and pass it any options that fit your needs.
* When your component renders, `useCreateBundleMutation` returns a tuple that includes:
* - A mutate function that you can call at any time to execute the mutation
* - An object with fields that represent the current status of the mutation's execution
*
* @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
*
* @example
* const [createBundleMutation, { data, loading, error }] = useCreateBundleMutation({
*   variables: {
*      input: // value for 'input'
*   },
* });
*/
function useCreateBundleMutation(baseOptions) {
	const options = {
		...defaultOptions,
		...baseOptions
	};
	return Apollo.useMutation(CreateBundleDocument, options);
}
const DbmEchoMessageDocument = gql`
    query DbmEchoMessage($message: String!) {
  echoMessage(message: $message) {
    string
  }
}
    `;
const GetAsinAttributesDocument = gql`
    query getAsinAttributes($productId: ID, $marketplace: String!, $asin: String!, $keys: [String!]) {
  attributes(
    productId: $productId
    marketplace: $marketplace
    asin: $asin
    keys: $keys
  ) {
    key
    value
    language
    publishResult {
      success
      status
    }
    version
  }
}
    `;
function useGetAsinAttributesLazyQuery(baseOptions) {
	const options = {
		...defaultOptions,
		...baseOptions
	};
	return Apollo.useLazyQuery(GetAsinAttributesDocument, options);
}
const GetHistoryViewBundlesDocument = gql`
    query getHistoryViewBundles($input: GetHistoryViewBundlesRequest!) {
  getHistoryViewBundles(input: $input) {
    totalEntries
    bundleEntities {
      id
      asin
      internalId
      bundleForm {
        autoGeneratedCreativeName
        baseComponent {
          asinAttributesMap
          asins
          program
          quantity
          type
        }
        bindingType
        components {
          asinAttributesMap
          asins
          program
          quantity
          type
        }
        embargoDate
        indexSuppression
        inheritBulletPoints
        launchDate
        launchGating
        marketplaceId
        preLaunch
        programParticipation
        thirdPartySiteExclusion
        title
        bullets
        autogenerateTitle
        autogenerateBulletPoints
      }
      submissionDate
      status
      errorRecord
    }
  }
}
    `;
/**
* __useGetHistoryViewBundlesQuery__
*
* To run a query within a React component, call `useGetHistoryViewBundlesQuery` and pass it any options that fit your needs.
* When your component renders, `useGetHistoryViewBundlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
* you can use to render your UI.
*
* @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
*
* @example
* const { data, loading, error } = useGetHistoryViewBundlesQuery({
*   variables: {
*      input: // value for 'input'
*   },
* });
*/
function useGetHistoryViewBundlesQuery(baseOptions) {
	const options = {
		...defaultOptions,
		...baseOptions
	};
	return Apollo.useQuery(GetHistoryViewBundlesDocument, options);
}
const ProgramNamesAndAsinDescriptionsDocument = gql`
    query ProgramNamesAndAsinDescriptions($firstPrograms: Int!, $firstAsins: Int!, $programFilters: ProgramFilterInput, $asinFilters: AsinFilterInput) {
  programs(first: $firstPrograms, filters: $programFilters) {
    nodes {
      ...programsInfo
    }
    totalCount
  }
  asins(first: $firstAsins, filters: $asinFilters) {
    nodes {
      ...asinsInfo
    }
  }
}
    ${ProgramsInfoFragmentDoc}
${AsinsInfoFragmentDoc}`;
function useProgramNamesAndAsinDescriptionsLazyQuery(baseOptions) {
	const options = {
		...defaultOptions,
		...baseOptions
	};
	return Apollo.useLazyQuery(ProgramNamesAndAsinDescriptionsDocument, options);
}
const DbmProgramsDocument = gql`
    query DbmPrograms($first: Int!, $filters: ProgramFilterInput) {
  programs(first: $first, filters: $filters) {
    nodes {
      ...programsInfo
    }
    totalCount
  }
}
    ${ProgramsInfoFragmentDoc}`;
/**
* __useDbmProgramsQuery__
*
* To run a query within a React component, call `useDbmProgramsQuery` and pass it any options that fit your needs.
* When your component renders, `useDbmProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
* you can use to render your UI.
*
* @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
*
* @example
* const { data, loading, error } = useDbmProgramsQuery({
*   variables: {
*      first: // value for 'first'
*      filters: // value for 'filters'
*   },
* });
*/
function useDbmProgramsQuery(baseOptions) {
	const options = {
		...defaultOptions,
		...baseOptions
	};
	return Apollo.useQuery(DbmProgramsDocument, options);
}
const CreateBundleSlateVariantsRecordDocument = gql`
    mutation createBundleSlateVariantsRecord($input: SaveBundleSlateVariantsInput!) {
  createBundleSlateVariantsRecord(input: $input) {
    baseAsin
    componentAsins
    obfuscatedMarketplaceId
    variants
  }
}
    `;
/**
* __useCreateBundleSlateVariantsRecordMutation__
*
* To run a mutation, you first call `useCreateBundleSlateVariantsRecordMutation` within a React component and pass it any options that fit your needs.
* When your component renders, `useCreateBundleSlateVariantsRecordMutation` returns a tuple that includes:
* - A mutate function that you can call at any time to execute the mutation
* - An object with fields that represent the current status of the mutation's execution
*
* @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
*
* @example
* const [createBundleSlateVariantsRecordMutation, { data, loading, error }] = useCreateBundleSlateVariantsRecordMutation({
*   variables: {
*      input: // value for 'input'
*   },
* });
*/
function useCreateBundleSlateVariantsRecordMutation(baseOptions) {
	const options = {
		...defaultOptions,
		...baseOptions
	};
	return Apollo.useMutation(CreateBundleSlateVariantsRecordDocument, options);
}

//#endregion
export { useCreateBundleMutation, useCreateBundleSlateVariantsRecordMutation, useDbmAsinsLazyQuery, useDbmAsinsQuery, useDbmProgramsQuery, useGetAsinAttributesLazyQuery, useGetHistoryViewBundlesQuery, useProgramNamesAndAsinDescriptionsLazyQuery };
//# sourceMappingURL=graphql.mjs.map